import React from "react";
import FileCategorySingleSelect from "components/file-category-single-select/file-category-single-select";
import SearchableSeriesSelect from "components/searchable-series-select/searchable-series-select";
import SearchableFilesTypesSelect from "components/searchable-files-types-select/searchable-files-types-select";

export interface SeriesTypeCategoryFieldsProps {
  seriesId: string;
  fileTypeId: string;
  categoryId: string;
  onSeriesChange: (id: string) => void;
  onFileTypeChange: (id: string) => void;
  onCategoryChange: (id: string) => void;
  hideCategory?: boolean;
  hideSeriesAndType?: boolean;
  /** Explains the series field, under it. */
  seriesHint?: string;
}

/** Series, file type, and category selects (same wiring as system branch of TemplateSlotCard). */
export function SeriesTypeCategoryFields({
  seriesId,
  fileTypeId,
  categoryId,
  onSeriesChange,
  onFileTypeChange,
  onCategoryChange,
  hideCategory = false,
  hideSeriesAndType = false,
  seriesHint,
}: SeriesTypeCategoryFieldsProps) {
  return (
    <div className="space-y-2">
      {!hideSeriesAndType && (
        <>
          <SearchableSeriesSelect
            value={seriesId}
            onChange={(value: string) => onSeriesChange(value)}
            isRequired={false}
          />
          {seriesHint && <p className="text-sm text-gray-600">{seriesHint}</p>}
          <SearchableFilesTypesSelect
            value={fileTypeId}
            onChange={(value: string) => onFileTypeChange(value)}
            isRequired={false}
          />
        </>
      )}
      {!hideCategory && (
        <FileCategorySingleSelect
          value={categoryId ? [categoryId] : []}
          onChange={(value: string[]) => onCategoryChange(value?.[0] || "")}
          isRequired={false}
          subject="customer"
        />
      )}
    </div>
  );
}
